import { TRIAL_SIGNUP_ROUTES, RENEW_SUBSCRIPTION_ROUTES } from './Routes';

export const FREE_SIGNUP_STEPS = [
  {
    path: TRIAL_SIGNUP_ROUTES.GETTING_STARTED,
    stepName: 'Getting Started',
  },
  {
    path: TRIAL_SIGNUP_ROUTES.CONTACT_DETAILS,
    stepName: 'Contact Details',
  },
  {
    path: TRIAL_SIGNUP_ROUTES.SELECT_PLANS,
    stepName: 'Select Plans',
  },
  {
    path: TRIAL_SIGNUP_ROUTES.PAYMENT_DETAILS,
    stepName: 'Payment Details',
  },
  {
    path: TRIAL_SIGNUP_ROUTES.BUSINESS_DETAILS,
    stepName: 'Business Details',
  },
];

export const RENEW_SUBSCRIPTION_STEPS = [
  {
    path: RENEW_SUBSCRIPTION_ROUTES.SELECT_PLANS,
    stepName: 'Select Plans',
  },
  {
    path: RENEW_SUBSCRIPTION_ROUTES.PAYMENT_DETAILS,
    stepName: 'Payment Details',
  }
]



// WEBPACK FOOTER //
// ./src/constants/Transactions.js